import { assert_equal } from '@shared/asserts/utils_asserts';
import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';
import { DTO__grid2d } from '@shared/dto/grid2d/DTO__grid2d';

export function recreate_chunk_indices_for_grid2d_user_task(grid2d: DTO__grid2d) {
  assert_equal(grid2d.entity_type, ENUM__workspace_entity.ENTITY_USER_TASK);

  let chunk_index = 0;

  for (let chunk of grid2d.chunks) {
    chunk.chunk_index = chunk_index;

    chunk_index++;
  }
}
